// extracted by mini-css-extract-plugin
export default {"wrapper":"mail-server-success-modal_wrapper__8uHrH","closeBtn":"mail-server-success-modal_closeBtn__r+mgc","opacity-transition":"mail-server-success-modal_opacity-transition__uaXTb"};